export default class MyLeaguesFilters {
  public type?: string = "PRIVATE";
  public userRole?: string = null;

  constructor(filters: any) {
    this.userRole = filters?.userRole || null;
  }

  constructFiltersUrl? = () => {
    let url = `&type=${this.type}`;

    if (this.userRole) {
      url += `&user_role=${this.userRole}`;
    }

    return url;
  };
}
